window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep(target, ...sources) {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof(CookieControl) === 'undefined') return;
  if (!window.cookieConfig) {
    window.cookieConfig = {}
  }
  window.cookieConfig = mergeDeep(window.cookieConfig, {
    initialState: 'notify',
    accessibility: {
      overlay: false
    },
    branding: {
      removeAbout: true,
      acceptBackground: '#7fca35',
      rejectBackground: '#005696'
    },
    statement: {
      description: 'For full details, please read our ',
      name: 'Privacy Policy',
      url: '/privacy-policy.html',
      updated: '01/02/2022'
    },
    //necessaryCookies: [],
    necessaryCookies: ['_ga', '_gcl_au', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv'],
    optionalCookies: [
      {
        name: 'ga',
        label: window.cookieLocalization?.ga?.label ?? 'Google Analytics',
        description: window.cookieLocalization?.ga?.description ?? 'Google Analytics helps us to improve our website by collecting and reporting information on its usage.',
        //cookies: ['_ga', '_gcl_au', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv'],
        cookies: [],
        vendors: [{
          name: 'Google',
          url: 'https://policies.google.com/technologies/types?hl=en-US',
          description: 'Google Analytics'
        }],
        onAccept: function () {
          gtag('consent', 'update', { 'analytics_storage': 'granted' });
        },
        onRevoke: function () {
          gtag('consent', 'update', { 'analytics_storage': 'denied' });

          // Disable Google Analytics
          window['ga-disable-UA-15856526-1'] = true;
          // End Google Analytics
        }
      },
      {
        name: 'fbpixel',
        label: window.cookieLocalization?.fb?.label ?? 'Facebook Pixel',
        description: window.cookieLocalization?.fb?.description ?? 'Facebook Pixels helps us improve the relevancy of advertising campaigns you receive.',
        cookies: ['fr', '_fbp'],
        onAccept: function () {
          // Add Facebook Pixel
          !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
              n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
          }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '856423134466372');
          fbq('track', 'PageView');
          fbq('consent', 'grant');
          // End Facebook Pixel
        },
        onRevoke: function () {
          fbq('consent', 'revoke');
        }
      },
      {
        name: 'bingbat',
        label: window.cookieLocalization?.bing?.label ?? 'Bing Analytics',
        description: window.cookieLocalization?.bing?.description ?? 'Bing Analytics helps us to improve our website by collecting and reporting information on its usage.',
        cookies: ['_clck', '_clsk', '_uetvid', '_uetsid'],
        onAccept: function () {
          // Bing Analytics
          (function (w, d, t, r, u) { var f, n, i; w[u] = w[u] || [], f = function () { var o = { ti: '5010795' }; o.q = w[u], w[u] = new UET(o), w[u].push('pageLoad') }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { var s = this.readyState; s && s !== 'loaded' && s !== 'complete' || (f(), n.onload = n.onreadystatechange = null) }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i) })(window, document, 'script', 'https://bat.bing.com/bat.js', 'uetq');
          // End Bing Analytics
        },
        onRevoke: function () {
        }
      },
      {
        name: 'callrail',
        label: window.cookieLocalization?.callrail?.label ?? 'CallRail',
        description: window.cookieLocalization?.callrail?.description ?? 'CallRail helps us to understand phone usage via links on our website.',
        cookies: ['calltrk_referrer', 'calltrk_landing'],
        onAccept: function () {
          // Add callrail
          var script = document.createElement('script');
          script.src = '//cdn.callrail.com/companies/921448608/66589ba18271e89f82ec/12/swap.js';
          document.head.appendChild(script);
          // End callrail
        },
        onRevoke: function () {
        },
        thirdPartyCookies: [{ 'name': 'CallRail', 'optOutLink': 'https://www.callrail.com/privacy/' }]
      }
    ]
  });

  CookieControl.load(window.cookieConfig);
})
